import OnboardingWizard from '../components/OnboardingWizard';

const OnboardingScene = () => {
  return (
    <div className="bg-brand-solid flex h-full w-full flex-col items-center justify-center">
      <OnboardingWizard />
    </div>
  );
};

export default OnboardingScene;
